import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Logic|Credentials Extended|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogCertLogicExtended';
export type SPCatalogCertLogicExtendedLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}ButtonHide`
	| `${LocNameStart}ButtonShow`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelNameAbbreviation`;

export const spCatalogCertLogicExtendedLocs: LocDefs<SPCatalogCertLogicExtendedLocNames> = {
	SPCatalogCertLogicExtendedTitleSection: {
		defaultValue: 'Credentials Extended by This One',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Credential/CatalogsCredential.ExtendedCerts.Title.SectionTitle',
		...sharedProperties,
	},
	SPCatalogCertLogicExtendedButtonHide: {
		defaultValue: 'Hide',
		description: 'Hide button',
		displayPath: `${pathStart}Hide`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.ExtendedCerts.Button.Hide',
		...sharedProperties,
	},
	SPCatalogCertLogicExtendedButtonShow: {
		defaultValue: 'Show',
		description: 'Show button',
		displayPath: `${pathStart}Show`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.ExtendedCerts.Button.Show',
		...sharedProperties,
	},
	SPCatalogCertLogicExtendedLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Credential/CatalogsCredential.ExtendedCerts.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCatalogCertLogicExtendedLabelNameAbbreviation: {
		defaultValue: 'Abbreviation',
		description: 'Column heading for: Abbreviation.',
		displayPath: `${pathStart}Abbreviation`,
		displayType: 'Label',
		legacyName: 'Credential/CatalogsCredential.ExtendedCerts.ColumnHeading.NameAbbr',
		...sharedProperties,
	},
};

export type SPCatalogCertLogicExtendedLocType = LocMap<SPCatalogCertLogicExtendedLocNames>;
